<div class="grid-6 copo-container footer-margin" *ngIf="segment && segment.bendingList && this.segment.bendingList.length > 0">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.mechanical.characteristics.bending</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block quadruple-column" *ngFor="let bending of segment.bendingList">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.number.bending</div>
						<div class="card-content-value">{{ bending.testNumber ? (bending.testNumber | copoNumber:'number'): UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.bend.indicator</div>
						<div class="card-content-value"> 
							<div *ngIf="bending.bendingIndicator === 'O'">
								<span translate>aqdb.oui</span>
								<span *ngIf="isTransmittedOnCertificateData(bending.indTrsBending)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
								<span *ngIf="isMeasuredData(bending.indTrsBending, bending.bendingIndicatorTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
								<span *ngIf="isModelledData(bending.indTrsBending, bending.bendingIndicatorTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
							</div>
							<div *ngIf="bending.bendingIndicator === 'N'">
								<span translate>aqdb.no</span>
								<span *ngIf="isTransmittedOnCertificateData(bending.indTrsBending)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
								<span *ngIf="isMeasuredData(bending.indTrsBending, bending.bendingIndicatorTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
								<span *ngIf="isModelledData(bending.indTrsBending, bending.bendingIndicatorTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
							</div>
							<div *ngIf="bending.bendingIndicator === 'Y'">
								<span translate>aqdb.yes</span>
								<span *ngIf="isTransmittedOnCertificateData(bending.indTrsBending)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
								<span *ngIf="isMeasuredData(bending.indTrsBending, bending.bendingIndicatorTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
								<span *ngIf="isModelledData(bending.indTrsBending, bending.bendingIndicatorTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
							</div>
							<div *ngIf="bending.bendingIndicator !== 'O' && bending.bendingIndicator !== 'N' && bending.bendingIndicator !== 'Y'">
								{{ UNDERSCORE }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
